import React, { useMemo, useRef } from 'react';

// Widgets
import Map from '../../widgets/project-map';
import DataValue from '../../widgets/data-value';
import ProjectDetails from '../../widgets/project-details';
import Recommendations from '../../sections/recommendations';
import SourceOfInformation from '../../widgets/sources-of-information';
import useFetchHelper from '../../../../../../../helpers/useFetchHelper';
import SubjectDataConsolidation from '../../widgets/subject-data-consolidation';
import InformationContributions from '../../sections/information-contributions';
import ContributorsAndSdgs from '../../sections/contributors-and-sdgs';
import { Style } from '../../../../../../../components/dashboards/SupplyChainSummaryProject/style';

const Monitoring = ({
  sources = [],
  data = {},
  selectedProject = null,
  t = (t) => t,
  language,
  projectData = null,
  user = null,
  organisationName = null,
  sourceId = null,
  isOwnData = true,
  sidebarCollapsed = false,
  retrived = false,
  openSettings = () => { },
  filterKey,
  settings,
}) => {
  const mapRef = useRef();

  const { canFetch: canFetchMap } = useFetchHelper({ ref: mapRef });
  const selectedProjectAndLanguage = useMemo(() => ({
    language,
    selectedProject,
  }), [language, selectedProject])

  const mapData = useMemo(() => {
    return data.map ? data.map.filter((d) => (
      (d.marker.lat > -85 && d.marker.lat < 85) &&
      (d.marker.lng > -180 && d.marker.lng < 180)
    )) : null;
  }, [data.map]);

  return (
    <Style className={sidebarCollapsed ? 'collapsed' : 'not-collapsed'}>
      <div className="row-section">
        <div className="flex-1 col-section">
          <ProjectDetails
            projectData={projectData}
            data={data.uniqueInformationSubjects}
            t={t}
          />
        </div>
        <div className="flex-1 col-section">
          <DataValue
            projectData={projectData}
            data={data}
            t={t}
          />
        </div>
      </div>
      <div className="flex-1" id="1a" style={{ flexDirection: 'column', marginTop: 24 }}>
        <SubjectDataConsolidation
          t={t}
          sidebarCollapsed={sidebarCollapsed}
          data={data.subjectDataConsolidation}
          valToResetFilters={selectedProjectAndLanguage}
          retrived={retrived}
          selectedProjectAndLanguage={selectedProjectAndLanguage}
          filterKey={filterKey}
        />
      </div>
      <SourceOfInformation
        t={t}
        user={user}
        data={data.sourcesOfInformation}
        clients={data.projectInformationClients}
        projectDatastakeId={(projectData && projectData.datastakeId) ? projectData.datastakeId : null}
        selectedProjectAndLanguage={selectedProjectAndLanguage}
      />
      <InformationContributions
        language={language}
        t={t}
        data={data.infromationContributorsIdentification}
        contributorsTasks={data.contributorsTasks}
        valToResetFilters={selectedProject}
        settings={settings}
      />
      <ContributorsAndSdgs
        language={language}
        t={t}
        data={data}
        settings={settings}
        contributorsTasks={data.contributorsTasks}
        valToResetFilters={selectedProject}
      />
      <Recommendations
        sources={sources}
        language={language}
        data={data.recommendations}
        valToResetFilters={selectedProject}
        organisationName={organisationName}
        isOwnData={isOwnData}
        allEvents={data.allEvents}
        t={t}
        project={projectData}
        user={user}
        id="9a"
      />
      <section ref={mapRef} id="10a">
        <Map
          t={t}
          openSettings={openSettings}
          data={mapData}
          user={user}
          filterKey={filterKey}
          projectData={projectData}
          selectedProject={selectedProject}
          language={language}
          sourceId={sourceId}
          isProject={true}
          canFetch={canFetchMap}
        />
      </section>
    </Style>
  );
};

export default Monitoring;
